import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/market_banner.png'
import _imports_1 from '@/assets/icons/smrz.svg'


const _hoisted_1 = { class: "person-center page-content" }
const _hoisted_2 = { class: "person-center__header" }
const _hoisted_3 = { class: "person-center__header__btns" }
const _hoisted_4 = { class: "person-center__header__info" }
const _hoisted_5 = { class: "user_info" }
const _hoisted_6 = {
  key: 1,
  class: "avatar"
}
const _hoisted_7 = { class: "name_scope" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "account" }
const _hoisted_10 = { class: "slogan" }
const _hoisted_11 = { class: "person-center__menus" }

import { useRouter } from "vue-router";
import { showToast } from "vant";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

const go = (path: string) => {
  if (path === '/Wallet' && userInfo.authentication !== 1) {
    showToast('请先进行实名认证')
    router.push('/RealNameAuth')
  } else {
    router.push(path);
  }
};

const copyText = (text: string) => {
  navigator.clipboard.writeText(text);
  showToast('已复制到剪贴板');
}

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "purches",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (go('/Wallet')))
        }, "口袋"),
        _createVNode(_component_el_icon, {
          size: "28",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (go('/Setting')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svgIcon, {
              name: "setting",
              size: "22"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(userInfo).avatar)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                class: "avatar",
                fit: "cover",
                src: _unref(userInfo).avatar
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_svgIcon, {
                  name: "avatar",
                  size: "75"
                })
              ])),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(userInfo).nickName) + " ", 1),
              (_unref(userInfo).gender === 0)
                ? (_openBlock(), _createBlock(_component_svgIcon, {
                    key: 0,
                    name: "male",
                    size: "20"
                  }))
                : _createCommentVNode("", true),
              (_unref(userInfo).gender === 1)
                ? (_openBlock(), _createBlock(_component_svgIcon, {
                    key: 1,
                    name: "female",
                    size: "20"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(" ID：" + _toDisplayString(_unref(userInfo).onlyCode) + " ", 1),
              _createVNode(_component_svgIcon, {
                class: "copy-icon",
                name: "copy",
                size: "12",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (copyText(_unref(userInfo).onlyCode)))
              })
            ])
          ]),
          _createElementVNode("div", {
            class: "user_info__edit",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (go('/EditProfile')))
          }, [
            _cache[11] || (_cache[11] = _createTextVNode(" 编辑资料 ")),
            _createVNode(_component_svgIcon, {
              name: "edit_arrow",
              size: "12"
            })
          ])
        ]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(userInfo).slogan), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: "person-center__market",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (go('/Shop')))
    }, _cache[12] || (_cache[12] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1)
    ])),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (go('/Dynamic')))
      }, [
        _createVNode(_component_svgIcon, {
          class: "menu-icon",
          name: "dynamic",
          size: "25"
        }),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "title" }, "动态", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ]),
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (go('/Collect')))
      }, [
        _createVNode(_component_svgIcon, {
          class: "menu-icon",
          name: "collect",
          size: "25"
        }),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "title" }, "收藏", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ]),
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (go('/Shop')))
      }, [
        _createVNode(_component_svgIcon, {
          class: "menu-icon",
          name: "shop",
          size: "25"
        }),
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "title" }, "兑换商城", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ]),
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (go('/RealNameAuth')))
      }, [
        _cache[16] || (_cache[16] = _createElementVNode("img", {
          class: "menu-icon",
          src: _imports_1
        }, null, -1)),
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "title" }, "实名认证", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ]),
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleHelpClick && _ctx.handleHelpClick(...args)))
      }, [
        _createVNode(_component_svgIcon, {
          class: "menu-icon",
          name: "feedback",
          size: "25"
        }),
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "title" }, "客服", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ]),
      _createElementVNode("div", {
        class: "person-center__menus__item",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (go('/About')))
      }, [
        _createVNode(_component_svgIcon, {
          class: "menu-icon",
          name: "about",
          size: "25"
        }),
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "title" }, "关于", -1)),
        _createVNode(_component_svgIcon, {
          class: "arrow-right",
          name: "arrow_right",
          size: "12"
        })
      ])
    ])
  ]))
}
}

})